export class SurveyResult {
  question = "";
  answerText = "";
  responseDate = "";
  type = "";
  change?: number;
}

export class AlertZone {
  color = "";
  startZone = 0;
  endZone = 0;
}

export enum AssessmentTypes {
  GAD7 = 1,
  PHQ9 = 2,
  SOWS = 3,
  Cravings = 4,
  BAM = 5
}